"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback } from "react";
import { IconCheckOutline18 } from "nucleo-ui-outline-18";
import { showToast } from "@/lib/toast";
import { useSmsNumbersVersion } from "@/lib/smsNumbersVersion";
import { SmsCodeVerifyFlow } from "./SmsCodeVerifyFlow";
interface SmsPhoneVerifyInputProps {
  label: string;
  description?: string;
  value: string;
  onChange: (value: string) => void;
  onPhoneChange?: (phoneNumber: string) => void;
  required?: boolean;
}
export function SmsPhoneVerifyInput(t0) {
  const $ = _c(20);
  const {
    label,
    description,
    value,
    onChange,
    onPhoneChange,
    required
  } = t0;
  const isVerified = Boolean(value);
  const invalidate = useSmsNumbersVersion(_temp);
  let t1;
  if ($[0] !== invalidate || $[1] !== onChange) {
    t1 = phone => {
      onChange(phone);
      invalidate();
      showToast.success(`Verified ${phone}`);
    };
    $[0] = invalidate;
    $[1] = onChange;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleVerified = t1;
  let t2;
  if ($[3] !== onChange) {
    t2 = () => {
      onChange("");
    };
    $[3] = onChange;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleReset = t2;
  let t3;
  if ($[5] !== required) {
    t3 = required && <span className="text-ds-brand-600 ml-0.5">*</span>;
    $[5] = required;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== label || $[8] !== t3) {
    t4 = <label className="text-ds-text-secondary block text-sm font-medium">{label}{t3}</label>;
    $[7] = label;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== description || $[11] !== handleReset || $[12] !== handleVerified || $[13] !== isVerified || $[14] !== onPhoneChange || $[15] !== value) {
    t5 = isVerified ? <div className="flex items-center gap-2"><div className="flex h-10 flex-1 items-center rounded-lg bg-green-50 px-3 font-mono text-sm text-green-700 dark:bg-green-900/20 dark:text-green-400"><IconCheckOutline18 className="mr-2 h-4 w-4 shrink-0" />{value}</div><button type="button" onClick={handleReset} className="text-ds-text-muted text-xs font-medium hover:underline">Change</button></div> : <><SmsCodeVerifyFlow onVerified={handleVerified} onPhoneChange={onPhoneChange} />{description && <p className="text-ds-text-muted text-xs leading-relaxed">{description}</p>}</>;
    $[10] = description;
    $[11] = handleReset;
    $[12] = handleVerified;
    $[13] = isVerified;
    $[14] = onPhoneChange;
    $[15] = value;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== t4 || $[18] !== t5) {
    t6 = <div className="space-y-1.5">{t4}{t5}</div>;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  return t6;
}
function _temp(s) {
  return s.invalidate;
}